// Port of api/fuel/app/classes/filter/search/games/filters/query/game/overload.php
import F from 'offline/filter/constants'

export default {
	name: 'game.overload',
	priority: 8,
	require: function(config, filter) { return filter.overload },
	run: function(config, filter, data, query) {
		query.where('g.game_type', '=', 2)
		if (config.ownerType === F.OWNER_USER) {
			query.select("(SELECT cp.game_id FROM collection cp WHERE cp.collection_id = CASE WHEN c.collection_nested = 1 THEN c.collection_nested_official ELSE c.collection_nested_custom END)", 'overload')
		} else {
			query.select('g.game_base', 'overload')
		}
	}
}
